import { put, takeEvery, call } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getContactDetails({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.contact_details.get, signal });
    yield put(actions.getContactDetailsDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getContactDetailsFailed,
      endpoint: api.contact_details.get.url
    });
  }
}

function* changeContact({ payload: { values, onSuccess, handledErrors } }) {

  try {
    const { data } = yield call(fetch, { api: api.contact_details.update, data: values, multipart: true });
    onSuccess();
    yield put(actions.changeContactDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.changeContactFailed,
      handledErrors,
      endpoint: api.contact_details.update.url
    });
  }
}

export const getContactDetailsSaga = takeEvery(types.GET_CONTACT_DETAILS_REQUEST, getContactDetails);
export const changeContactSaga = takeEvery(types.CHANGE_CONTACT_REQUEST, changeContact);